/** Route presentations supported by the map and video composition. */
export const ROUTE_LINE_STYLE_IDS = ["standard", "pipe"] as const;
export type RouteLineStyleId = (typeof ROUTE_LINE_STYLE_IDS)[number];
export const DEFAULT_ROUTE_LINE_STYLE_ID: RouteLineStyleId = "standard";
export const ROUTE_LINE_STYLES = [
  { id: "standard", label: "Line" },
  { id: "pipe", label: "Pipe" },
] as const;

/** Accepts only a supported route presentation. */
export function isRouteLineStyleId(candidate: string): candidate is RouteLineStyleId {
  return ROUTE_LINE_STYLE_IDS.some((id) => id === candidate);
}
